import { matchPath } from "react-router-dom";
import Layout from "../pages/Layout";
import Brands from "../pages/Brands";
import Live from "../pages/Live";
import Login from "../pages/Login";
import PinLogin from "../pages/PinLogin";
import MigratingToStarzplay from "../pages/MigratingToStarzplay";
import GoToStarzplay from "../pages/GoToStarzplay";
import Search from "../pages/Search";
import DetailPage from "../pages/DetailPage";
import FullCatalog from "../pages/FullCatalog";
import MyLibrary from "../pages/MyLibrary";
import Splash from "../pages/Splash";
import Settings from "../pages/Settings";
import ParentalControl from "../pages/ParentalControl";
import EpisodesSelectorPage from "../pages/EpisodesSelectorPage";
import Signup from "../pages/Signup";
import VoucherRedemption from "../pages/VoucherRedemption";
import ThankYou from "../pages/ThankYou";
import Landing from "../pages/Landing";

export const sections = {
  HOME: "home",
  SPORTS: "sports",
  SERIES: "series",
  MOVIES: "movies",
  ARABIC: "arabic",
  KIDS: "kids",
  DISCOVERY: "discovery",
  UFC: "ufc",
  BLUTV: "blutv",
  PREMIERSPORTS: "premiersports",
  ADSPORTS: "adsports",
  CRICLIFE: "criclife",
  MAJIDTV: "majidtv",
  GOLFTV: "golftv",
  FIFA: "fifa",
  BRANDS: "brands",
  LIVE: "live",
  MYLIBARAY: 'mylist',
  BRANDS_NAME: "brands_name",
  SEARCH: "search"
};

export const routes = {
  splash: "/",
  login: "/login",
  pin: "/pin",
  migratingtostarzplay: "/migratingtostarzplay",
  gotostarzplay: "/gotostarzplay",
  search: `/${sections.SEARCH}`,
  home: `/${sections.HOME}`,
  sports: `/${sections.SPORTS}`,
  series: `/${sections.SERIES}`,
  movies: `/${sections.MOVIES}`,
  arabic: `/${sections.ARABIC}`,
  kids: `/${sections.KIDS}`,
  [sections.LIVE]: `/${sections.LIVE}`,
  [sections.BRANDS]: `/${sections.BRANDS}`,
  [sections.BRANDS_NAME]: `/${sections.BRANDS}/:name`,
  explore: "/explore",
  mylibrary: "/mylibrary",
  settings: "/settings",
  parentalControl: "/parentalControl",
  exit: "/exit",
  signup: "/signup",
  redeem: "/redeem",
  thankyou: "/thankyou",
  landing: "/landing",
  player: "/player"
};

// FIXME: make routes for the descovery dynamic like other pages

const pages = [
  {
    route: routes.splash,
    name: "Splash",
    component: Splash,
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: routes.settings,
    name: "Settings",
    component: Settings,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.login,
    name: "Login",
    component: Login,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.pin,
    name: "Pin",
    component: PinLogin,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.gotostarzplay,
    name: "Gotostarzplay",
    component: GoToStarzplay,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.migratingtostarzplay,
    name: "MigratingToStarzplay",
    component: MigratingToStarzplay,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.search,
    name: "Search",
    component: Search,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.home,
    name: "Home",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.sports,
    name: "Sports",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.series,
    name: "Series",
    component: Layout,
    isRoot: true
  },
  {
    route: `${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.series}`,
    name: "Series Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.sports}`,
    name: "Sports Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.movies,
    name: "Movies",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.movies}`,
    name: "Movies Full Catalog",
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.arabic,
    name: "Arabic",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.arabic}`,
    name: "Arabic Full Catalog",
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.kids,
    name: "Kids",
    component: Layout,
    subtheme: "kids",
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.kids}`,
    name: "Kids Full Catalog",
    component: FullCatalog,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.mylibrary,
    name: "My Library",
    component: MyLibrary,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },

  {
    route: routes.parentalControl,
    name: "Parental Control",
    component: ParentalControl,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.exit,
    name: "Exit",
    component: Layout,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.signup,
    name: "Signup",
    component: Signup,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.redeem,
    name: "VoucherRedemption",
    component: VoucherRedemption,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.thankyou,
    name: "ThankYouPage",
    component: ThankYou,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.landing,
    name: "LandingPage",
    component: Landing,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes[sections.BRANDS_NAME],
    name: "brand name",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes[sections.BRANDS_NAME]}`,
    name: ` Full Catalog`,
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.brands,
    name: "Brands",
    component: Brands,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.live,
    name: "Live",
    component: Live,
    kidsAllowed: false,
    isRoot: true
  }
];

const cache = new Map();

export const getRouteByPath = path => {
  if (!cache.has(path)) {
    cache.set(
      path,
      pages.find(page =>
        matchPath(path, {
          path: page.route,
          exact: true,
          strict: false
        })
      )
    );
  }
  return cache.get(path);
};

export const isRootPath = path => (path.match(/\//g) || []).length === 1;

export default { pages };
